import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import YouTube from 'react-youtube';

import { SimpleModal } from 'components/Shared';

const opts = {
  height: '600',
  width: '800',
  playerVars: {
    // https://developers.google.com/youtube/player_parameters
    autoplay: 1,
  },
};

const onReady = event => {
  // access to player in all event handlers via event.target
  event.target.playVideo();
};

function ViewProductDemo() {
  const dispatch = useDispatch();
  const {
    viewProductDemo: { show = false },
  } = useSelector(state => state.modal);
  return (
    <SimpleModal
      fullWidth
      maxWidth="md"
      open={show}
      onClose={() => dispatch({ type: 'HIDE_PRODUCT_DEMO' })}
      transparentBackground
    >
      <div className="tw-full tw-flex tw-justify-center tw-items-center tw-content-center tw-mb-8">
        <YouTube videoId="k3GGxnQaPVs" opts={opts} onReady={onReady} />
      </div>
    </SimpleModal>
  );
}

export { ViewProductDemo };
